import React from 'react'
import { Query } from 'react-apollo'
import { GET_STORAGE_ALIASES } from 'operations/Object'
import { GET_API_KEYS } from 'operations/Auth'
import Sources from 'components/Sources'
import ApiKeys from 'components/ApiKeys'
import Button from 'components/Button'
import AddSource from 'components/AddSource';
import jwtDecode from 'jwt-decode'
import Grid from 'components/CSSGrid'
import AddApiKey from '../../components/AddApiKey';

export function Settings() {

    return (
        <React.Fragment>
            <h1>Settings</h1>
            
            <StorageAliases />

        </React.Fragment>
    )

}

class StorageAliases extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            addSource: false,
            addApiKey: false,
            token: localStorage.getItem('accessToken') || null
        }
        this.handleCloseAddSource = this.handleCloseAddSource.bind(this)
        this.handleCloseAddApiKey = this.handleCloseAddApiKey.bind(this)
    }

    handleCloseAddSource = () => {
        this.setState({
            addSource: false
        })
    }

    handleCloseAddApiKey = () => {
        this.setState({
            addApiKey: false
        })
    }

    render() {

        const { aID } = jwtDecode(this.state.token)

        return(
            <React.Fragment>

                {
                    this.state.addSource ? <AddSource onClose={ this.handleCloseAddSource } /> : null
                }

                {
                    this.state.addApiKey ? <AddApiKey onClose={ this.handleCloseAddApiKey } /> : null
                }

                <h2>Remote Sources</h2>
                <Button onClick={() => { this.setState({ addSource: true }) }}>Add source</Button>
                <Query query={ GET_STORAGE_ALIASES }>
                    {({ loading, error, data }) => {
                        if (loading) return "Loading..."
                        // if (error) return `Error! ${error.message}`
                        if (error) return null
                        return(
                            <Grid>
                                {
                                    !data ? null : <Sources sources={ data.storageAliases } aID={ aID }/>
                                }
                            </Grid>
                        )
                    }}
                </Query>

                <h2>API Keys</h2>
                <Button onClick={() => { this.setState({ addApiKey: true }) }}>Add API key</Button>
                <Query query={ GET_API_KEYS }>
                    {({ loading, error, data }) => {
                        if (loading) return "Loading..."
                        if (error) return null
                        return (
                            <Grid>
                                {
                                    !data ? null : <ApiKeys apiKeys={ data.apiKeys }/>
                                }
                            </Grid>
                        )
                    }}
                </Query>

            </React.Fragment>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/Settings/index.js